import { jsxs as s, jsx as t } from "@emotion/react/jsx-runtime";
import { AvatarContainer as v, ProfileContainer as A, IconContainer as C, StyledTextAvatar as T, BubbleContainer as U } from "./Avatar.styled.js";
import { Icon as g } from "../Icon/index.js";
const j = (r) => r ? r.length <= 3 ? r.toUpperCase() : r.charAt(0).toUpperCase() : "", B = ({
  shape: r = "default",
  image: n,
  bubbles: e,
  size: o = 50,
  text: m,
  backgroundColor: c,
  textColor: i,
  textSize: f = 18,
  iconSize: d,
  border: p = !0
}) => {
  const a = typeof n == "object", u = a ? null : j(m);
  return /* @__PURE__ */ s(v, { size: o, children: [
    /* @__PURE__ */ t(A, { size: o, shape: r, border: p, backgroundColor: c, image: a ? void 0 : n, bubbles: e, children: a ? /* @__PURE__ */ t(C, { shape: r, backgroundColor: c, children: /* @__PURE__ */ t(g, { icon: n, color: i, iconSize: d }) }) : /* @__PURE__ */ t(T, { shape: r, backgroundColor: "transparent", textColor: i, textSize: f, children: u }) }),
    e?.map(({
      position: l = "bottom-right",
      element: h
    }) => /* @__PURE__ */ t(U, { size: o, position: l, children: h }, l))
  ] });
};
export {
  B as Avatar
};
